import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import Loader from './Loader';

const PrivateRoute = ({ children }) => {
  const { token, loading } = useAuth();
  
  // Also check localStorage directly in case context hasn't updated yet
  const storedToken = localStorage.getItem('token');

  if (loading) {
    return <Loader variant="light" fullScreen />;
  }

  // Use token from context or localStorage
  const hasToken = token || storedToken;
  
  if (!hasToken) {
    return <Navigate to="/qr-login" replace />;
  }

  return children;
};

export default PrivateRoute;
